export default [
    {
      path: '/admin/agency/request-deliveries',
      name: 'request-delivery',
      meta: { requiresAuth: true },
      component: () => import('@/pages/agency/request-delivery/index.vue')
    }
  ]
